// extracted by mini-css-extract-plugin
export default {"wrapper":"loading-screen_wrapper__l5Lhw"};